// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationUploadPath = 'M31.529 2h37.97c9.65 0 17.5 7.85 17.5 17.5v52.84H73.76L22.467 84.198 6.62 15.668l24.909-5.751V2zm7 7v56.34h41.47V25.77h-16.8V9h-24.67zM27.711 75.802l-12.693-54.89 16.511-3.811V72.34h11.155l-14.973 3.462zM70.199 18.77h9.763c-.361-5.217-4.542-9.388-9.763-9.734v9.734zm-15.2 79.73h7v-17h-7v17zm19-7h-7v-12h7v12zm-31 4h7v-11h-7v11zm7.411-48.465l-4.95-4.95L58.495 29.05l13.034 13.035-4.949 4.95-4.585-4.585V57h-7V42.45l-4.585 4.585z';
var IllustrationUpload = baseIllustration('IllustrationUpload', {
  getPath: () => IllustrationUploadPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationUpload;
//# sourceMappingURL=index.js.map